"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ellipsis = void 0;
/**
 * Обрезает слишком длинный текст и к концу строки добавляется многоточие.
 * @param text Исходный текст
 * @param maxLength максимальная длина строки
 * @returns строка длиной не более чем указанную в maxLength
 */
function ellipsis(text, maxLength) {
    return text.length > maxLength ? "".concat(text.slice(0, maxLength - 1), "\u2026") : text;
}
exports.ellipsis = ellipsis;
//# sourceMappingURL=ellipsis.js.map